// extracted by extract-css-chunks-webpack-plugin
module.exports = {"right_box":"right_box-2HJdtflY","stock_box":"stock_box-3bLe6MZT"};